import { LocationVarKey } from "@swivl-mono/types";

import { IF_ANY, IS_EQUAL, IS_NOT_EQUAL, IS_TRUE, PageKey } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: PageKey[] = [
  LocationVarKey.FeatureAuction1,
  LocationVarKey.FeatureWonAuction1,
  LocationVarKey.FeatureWonAuction2,
  LocationVarKey.AfterNavigateAuction,
  {
    key: LocationVarKey.AfterNavigateAuction1,
    hideIf: IF_ANY([
      IS_NOT_EQUAL(LocationVarKey.HasAuctions, "1"),
      IS_NOT_EQUAL(LocationVarKey.AfterNavigateAuction, "1"),
      IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")
    ])
  },
  {
    key: LocationVarKey.AfterNavigateAuction2,
    hideIf: IF_ANY([
      IS_NOT_EQUAL(LocationVarKey.HasAuctions, "1"),
      IS_NOT_EQUAL(LocationVarKey.AfterNavigateAuction, "1"),
      IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")
    ])
  }
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Auctions{" "}
      </PageHeader>

      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.FeatureAuction1} />

      <SectionHeader {...page}> Auction Winners</SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.FeatureWonAuction1} />

      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.FeatureWonAuction2}
        enableSwitchVar={LocationVarKey.FeatureWonAuction2Enabled}
      />

      <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.HasAuctions, "1")}>
        <SwitchRow {...page} keyName={LocationVarKey.AfterNavigateAuction} label="Ask if they want to be navigated to your Auctions URL" />
        <Section
          {...page}
          hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.AfterNavigateAuction, "1"), IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")])}
        >
          <SectionHeader {...page}> After Navigate</SectionHeader>
          <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.AfterNavigateAuction1} />
          <TextAreaRow
            {...page}
            marginTop
            label=" Message 2 (Optional)"
            keyName={LocationVarKey.AfterNavigateAuction2}
            enableSwitchVar={LocationVarKey.AfterNavigateAuction2Enabled}
          />
        </Section>
      </Section>
    </>
  );
}
